export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";